import { AppTheme, DEFAULT_RETRY_CONFIG } from 'common/constants';
import {
  API_SET_LOCATION,
  GET_APP_CONFIG,
  GET_APP_CONFIG_DAY_REPORT_FIELDS,
  GET_APP_CONFIG_ROYALTY,
} from 'common/constants/apis';
import {
  AppConfigResp,
  AppConfigResponse,
  AppLanguageResp,
  AuthResp,
  AppConfig,
  GetAppConfigQueryParams,
  Language,
  ResourceBundle,
  ResourceBundleResp,
  ServerResponse,
  DayReportFieldsResponse,
  IRoyaltyConfigResponse,
} from 'common/interfaces';
import { UiThemeAssetsResp } from 'common/interfaces/itheme';
import UILogger from 'common/utils/logger';
import httpClient from './config';
import { AxiosRequestConfig } from 'axios';

export const fetchAppConfig = async (appVersionId: string): Promise<AppConfigResp> => {
  UILogger.log('Fetching configs for the app: ', appVersionId);
  const baseConfig: any = {
    status: { success: true },
    data: {
      appVersionId,
      localInfo: { currency: 'USD' },
      defaultListSize: 10,
      maxUploadableFileSize: 10 * 1048576, //10MB
      cdnUrl: 'https://d25rulwhuampvs.cloudfront.net',
    } as AppConfig,
  };

  return baseConfig;
};

export const fetchAvailableLanguages = (appId: number): Promise<AppLanguageResp> => {
  UILogger.log('Fetching Available Languages for the app: ', appId);
  const langs = [];
  return Promise.resolve({
    status: { success: true },
    data: [
      {
        name: 'English',
        key: 'en_US',
        letters: 'Aa',
      } as Language,
      { name: 'हिंदी', key: 'hi_in', letters: 'आ' } as Language,
      { name: 'தமிழ்', key: 'ka_in', letters: 'ஆ' } as Language,
      { name: 'ಕನ್ನಡ', key: 'tm_in', letters: 'ಎ' } as Language,
      { name: 'తెలుగు', key: 'tl_in', letters: 'ఒ' } as Language,
      { name: 'മലയാളം', key: 'ml_in', letters: 'അ' } as Language,
    ] as Array<Language>,
  } as AppLanguageResp);
};

export const postPreferredLanguage = (language: string): Promise<ServerResponse> => {
  UILogger.log('Updating preferred language:, ', language);
  const dummy = {
    status: { success: true },
  } as AuthResp;
  return Promise.resolve(dummy);
};

export const fetchLanguageData = (languageKey: string): Promise<ResourceBundleResp> => {
  UILogger.log('Fetching lang resource bundle:, ', languageKey);

  const dummy = {
    status: { success: true },
    data: TEMP_LANGS.getResBundle(languageKey),
  } as ResourceBundleResp;
  return Promise.resolve(dummy);
};

const TEMP_LANGS = {
  hi: {} as ResourceBundle,
  en_US: {} as ResourceBundle,
  getResBundle: function (lang: string) {
    if (lang === 'en_US') {
      return TEMP_LANGS.en_US;
    } else if (lang == 'hi_in') {
      return TEMP_LANGS.hi;
    }
  },
} as {
  hi: ResourceBundle;
  en_US: ResourceBundle;
  getResBundle: (lang: string) => ResourceBundle;
};

export const fetchThemeAssets = (themeName: AppTheme | string): Promise<UiThemeAssetsResp> => {
  UILogger.log('Fetching ui theme assets:, ', themeName);

  const dummy = {
    status: { success: true },
    data: {
      colors: {
        // primaryText: themeName === AppTheme.DARK ? 'white' : 'green',
      },
    },
  } as UiThemeAssetsResp;
  return Promise.resolve(dummy);
};

export const setAppLocation = async (lat: number, lng: number): Promise<ServerResponse> => {
  UILogger.log('[setAppLocation] [UpdateAppLocation] updating app location: ', lat, ' ', lng);
  return httpClient
    .put(API_SET_LOCATION, { lat, lng }, {
      retry: 3,
      retryDelay: 500,
    } as any)
    .then((res) => {
      UILogger.log('[setAppLocation] [UpdateAppLocation] Update Location SuccessFul', res?.data);
      return res?.data;
    })
    .catch((err) => {
      UILogger.log('[setAppLocation] [UpdateAppLocation] Server error: ', err);
      return { status: { success: false } } as ServerResponse;
    });
};

export const publishLogs = async (eventLogs: string[]) => {
  httpClient.put('api/v1/submitLogs', {
    eventLogs,
  });
};

export const getUserAppConfig = async (params: GetAppConfigQueryParams): Promise<AppConfigResponse> => {
  UILogger.log('getUserAppConfig params::', params);
  return httpClient
    .get(GET_APP_CONFIG, {
      params,
      ...DEFAULT_RETRY_CONFIG,
    })
    .then((res) => {
      UILogger.log('getUserAppConfig result::', res?.data);
      return res?.data;
    })
    .catch((err) => {
      UILogger.error('getUserAppConfig err::', err);
      return {
        status: {
          success: false,
          errorMessage: err.msg || err.message || err.errorMessage,
        },
      };
    });
};

export const getDayReportFields = async (): Promise<DayReportFieldsResponse> => {
  UILogger.log('getting DayReportFields...');
  return httpClient
    .get(GET_APP_CONFIG_DAY_REPORT_FIELDS, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then((res) => {
      UILogger.log('getDayReportFields result::', res?.data);
      return res?.data;
    })
    .catch((err) => {
      UILogger.error('getDayReportFields err::', err);
      return {
        status: {
          success: false,
          errorMessage: err.msg || err.message || err.errorMessage,
        },
      };
    });
};

export const getRoyaltyConfigs = async (): Promise<IRoyaltyConfigResponse> => {
  UILogger.log('getting DayReportFields...');
  return httpClient
    .get(GET_APP_CONFIG_ROYALTY, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then((res) => {
      UILogger.log('getDayReportFields result::', res?.data);
      return res?.data;
    })
    .catch((err) => {
      UILogger.error('getDayReportFields err::', err);
      return {
        status: {
          success: false,
          errorMessage: err.msg || err.message || err.errorMessage,
        },
      };
    });
};
